export const PERMISSIONS = Object.freeze(['feedback:manage', 'users:view', 'users:manage']);
export const ROLES = Object.freeze(['member', 'admin', 'super_admin']);
export const FEEDBACK_CATEGORIES = Object.freeze(['suggestion', 'bug', 'feature']);
export const FEEDBACK_STATUSES = Object.freeze(['new', 'reviewing', 'planned', 'resolved', 'declined']);

export function publicUser(row) {
  let permissions;
  try { permissions = Array.isArray(row.permissions) ? row.permissions : JSON.parse(row.permissions || '[]'); } catch { permissions = []; }
  const role = ROLES.includes(row.role) ? row.role : 'member';
  return {
    id: row.id, email: row.email, username: row.username || null, role,
    permissions: role === 'super_admin' ? [...PERMISSIONS] : role === 'admin' && Array.isArray(permissions) ? PERMISSIONS.filter(permission => permissions.includes(permission)) : [],
    disabled: Boolean(row.disabled), mustChangePassword: Boolean(row.must_change_password ?? row.mustChangePassword), createdAt: row.created_at ?? row.createdAt
  };
}
export function hasPermission(user, permission) {
  return Boolean(user && !user.disabled && (user.role === 'super_admin' || user.role === 'admin' && user.permissions?.includes(permission)));
}
